const SELECT_NEWSROOM = 'Newsroom/SELECT';

export default SELECT_NEWSROOM;
